import PageRequest from '../../../../../pagination-helper/lib/PageRequest';
import EnumUserStatus from '../../../../../users/base/enums/EnumUserStatus';

/**
 * * Модель запроса на получение списка команды пользователя с правами
 */
export default class GetEmployeesForManagerListWithAccessRequest  {
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	/**
	 * * Статусы которые следует отобразить
	 */
	Statuses!: Array<EnumUserStatus>;
	/**
	 * * Номер пользователя
	 */
	UserId?: number;
	/**
	 * * Номер рабочей области
	 */
	NamespaceId?: string;
	/**
	 * * Номер проекта
	 */
	ProjectId?: number;
	constructor(obj?: Partial<GetEmployeesForManagerListWithAccessRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
